export default "__VITE_ASSET__a184b33d__"